// Material UI
import { makeStyles } from '@material-ui/styles'
// Consts
import Colors from '../../constants/Colors'

export default makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Poppins',
    fontSize: '17px',
    height: '100%',
    [theme.breakpoints.up('md')]: {
      padding: '0px 24px',
    },
  },
  actions: {
    borderTop: `1px solid ${Colors.DISABLED_COLOR}`,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '20px 16px',
  },
  button: {
    marginLeft: '20px',
    minWidth: '110px',
  },
  cancelButton: {
    color: Colors.SECONDARY_FONT_COLOR,
    fontSize: '13px !important',
    lineHeight: 'normal',
  },
  productsContainer: {
    height: '100%',
    overflow: 'auto',
    flex: '1 1 1px',
    display: 'grid',
    gridAutoFlow: 'row',
    gridAutoRows: 'min-content',
    gridRowGap: 10,
  },
  label: {
    fontSize: 16,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    padding: '40px 16px',
    [theme.breakpoints.up('md')]: {
      padding: '40px 0px',
    },
  },
}))
